import { IsNotEmpty, IsOptional } from 'class-validator';
import { Mapper } from '../../../common/ddd/mapper.base';
import { IOrgWorkingSessionsAnalyticsActivityEnum } from '../../../common/enum/working-sessions/org-working-sessions-analytics-activity.enum';
import { ChallengeFocusScoreEntity } from '../../../core/domain/entities/challenge-insights/challenge-focus-score.entity';
import { ListAccountMetricsInsightsSummariesResponse } from '../../../interface/dtos/challenge-insights/list-account-metrics-insights-summary.result.dto';

export class ChallengeFocusScorePersistenceResponse {
  @IsNotEmpty()
  [IOrgWorkingSessionsAnalyticsActivityEnum.DayCount]: string;
  @IsNotEmpty()
  [IOrgWorkingSessionsAnalyticsActivityEnum.TotalDuration]: string;
  @IsNotEmpty()
  [IOrgWorkingSessionsAnalyticsActivityEnum.TotalFocusDuration]: string;
  @IsNotEmpty()
  [IOrgWorkingSessionsAnalyticsActivityEnum.UserId]: string;
  @IsOptional()
  [IOrgWorkingSessionsAnalyticsActivityEnum.LocalSessionStartDate]: string;
}

export class ChallengeFocusScoreMapper
  implements
    Omit<
      Mapper<
        ChallengeFocusScoreEntity,
        ListAccountMetricsInsightsSummariesResponse
      >,
      'toResponse'
    >
{
  toDomain(
    record: ChallengeFocusScorePersistenceResponse
  ): ChallengeFocusScoreEntity {
    return ChallengeFocusScoreMapper.toDomain(record);
  }

  static toDomain(
    record: ChallengeFocusScorePersistenceResponse
  ): ChallengeFocusScoreEntity {
    const entity = ChallengeFocusScoreEntity.create({
      value:
        Number(
          record[IOrgWorkingSessionsAnalyticsActivityEnum.TotalDuration]
        ) !== 0
          ? (Number(
              record[
                IOrgWorkingSessionsAnalyticsActivityEnum.TotalFocusDuration
              ]
            ) /
              Number(
                record[IOrgWorkingSessionsAnalyticsActivityEnum.TotalDuration]
              )) *
            100
          : 0,
      count: Number(record[IOrgWorkingSessionsAnalyticsActivityEnum.DayCount]),
      userId: String(record[IOrgWorkingSessionsAnalyticsActivityEnum.UserId]),
      date:
        String(
          record[IOrgWorkingSessionsAnalyticsActivityEnum.LocalSessionStartDate]
        ) || undefined,
    });
    return entity;
  }
}
